import React from 'react';
import { Link } from 'react-router-dom';

function NavBar() {
    return (
        <nav className="navbar navbar-light px-3 d-lg-none border-b border-blue-200 bg-white">
            <Link className="navbar-brand" to="/dashboard">
                <img src="/img/logo.png" alt="NeuraTrader" style={{ width: 120, height: 'auto' }} />
            </Link>
            <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#sidebarMenu"
                aria-controls="sidebarMenu"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon" />
            </button>
        </nav>
    );
}

export default NavBar;